import { useCallback, useMemo } from "react";
import { Row } from "react-data-grid";
import { COLORS } from "../../../consts/index.js";
import { hexToRgba, safeColor } from "./harvestEntryHelpers.js";

export function useHarvestEntryVisuals({ visibleRows }) {
  const borderGray = safeColor("#d9d9d9", COLORS?.gray);
  const selectionColor = safeColor("#39f", COLORS?.primaryBlue);
  const selectionFill = hexToRgba(selectionColor, 0.18);
  const bayStripeColors = ["#ffffff", "#eeeeee"];

  const bayStripeByName = useMemo(() => {
    const map = new Map();
    let idx = 0;
    for (const r of visibleRows || []) {
      const bay = r?.bay_name;
      if (!bay) continue;
      if (!map.has(bay)) {
        map.set(bay, idx % bayStripeColors.length);
        idx += 1;
      }
    }
    return map;
  }, [visibleRows, bayStripeColors.length]);

  const renderRow = useCallback(
    (key, props) => {
      const bayName = props.row?.bay_name;
      const stripeIdx = bayStripeByName.get(bayName) ?? 0;
      const rowStyle = !props.isRowSelected
        ? {
            ...props.style,
            backgroundColor: bayStripeColors[stripeIdx],
          }
        : props.style;
      return <Row key={key} {...props} style={rowStyle} />;
    },
    [bayStripeByName, bayStripeColors],
  );

  return {
    borderGray,
    selectionColor,
    selectionFill,
    renderRow,
  };
}
